export default "__VITE_ASSET__CD7I$kc1__"